import { Alert, Snackbar } from "@mui/material";
import { hideMessage } from "../../store/slices/appMessageSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

const AppMessageModal = () => {
  const dispatch = useAppDispatch();
  const { visible, message, type } = useAppSelector(
    (state) => state.appMessage,
  );

  return (
    <Snackbar
      open={visible}
      autoHideDuration={3500}
      onClose={() => dispatch(hideMessage())}
    >
      <Alert
        severity={
          type === "error" ? "error" : type === "success" ? "success" : "info"
        }
        onClose={() => dispatch(hideMessage())}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppMessageModal;
